module.exports = __webpack_public_path__ + "static/media/QualityPic01.9598e432.jpg";